export default __webpack_public_path__ + "static/media/logo-impact-sdg8.e0206f2f.svg";